import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import format from 'date-fns/format';

import { links } from '[theme-lib]/links';

const TIME_FORMAT = 'h:mm a';

// Date as a Date() or in ISO-8601 format will do
const dateOrString = PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]);

const TrolleyMenuBookingSlot = ({ deliverySlot }) => deliverySlot && (
  <div className="hd-trolleyMenuHeader__bookingSlot">
    <Link
      className="hd-trolleyMenuHeader__bookingSlotLink"
      to={links.CHANGE_DELIVERY}
    >
      <div className="hd-trolleyMenuHeader__bookingSlotDateTime">
        {format(deliverySlot.startTime, 'MMM DD')}
        <b className="hd-trolleyMenuHeader__bookingSlotTime">
          {format(deliverySlot.startTime, TIME_FORMAT)} - {format(deliverySlot.endTime, TIME_FORMAT)}
        </b>
      </div>
      {deliverySlot.expirationTime && (
        <div className="hd-trolleyMenuHeader__bookingSlotValid">
          Held until {format(deliverySlot.expirationTime, TIME_FORMAT)}
        </div>
      )}
    </Link>
  </div>
);

TrolleyMenuBookingSlot.propTypes = {
  deliverySlot: PropTypes.shape({
    startTime: dateOrString.isRequired,
    endTime: dateOrString.isRequired,
    expirationTime: dateOrString,
  }),
};

export default TrolleyMenuBookingSlot;
